import { Component, Input, Output, EventEmitter } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { TooltipModule } from "ngx-bootstrap/tooltip";
import { RouterModule } from "@angular/router";
import { VFIconComponent } from "../../../../vficon/vficon.component";
import { CellChangeEvent, TableBackgroundColors, TableCell, TableRow } from "../../../../../models/common-table";
import { CommonTableGridHandlers } from "../common-table-grid.component";
import {
  getCellValueAsArray,
  getCellValueAsString,
  getCellValueAsStringOrDash,
  getTooltipValue,
  getIconNameValue,
  getIconNameByIndexValue,
  cellValueIncludes,
  getCellValueLength,
} from "../../../../../utils/common-table.utils";

@Component({
  selector: "app-cell-type-renderer",
  standalone: true,
  imports: [CommonModule, FormsModule, TooltipModule, RouterModule, VFIconComponent],
  templateUrl: "./cell-type-renderer.component.html",
  styleUrls: ["../../../common-table.component.scss"],
})
export class CellTypeRendererComponent {
  @Input() cell: TableCell<unknown> | undefined;
  @Input() rowIndex!: number;
  @Input() colIndex!: number;
  @Input() columnTitle!: string;
  @Input() handlers!: CommonTableGridHandlers;
  @Input() backgroundColors!: TableBackgroundColors;
  @Input() emptyValues: string[] = [];
  @Input() row: TableRow | undefined;

  @Output() cellChange: EventEmitter<CellChangeEvent> = new EventEmitter<CellChangeEvent>();

  public readonly isArray: (value: unknown) => value is unknown[] = Array.isArray;

  // Utility functions exposed for template use.
  public readonly getCellValueAsArray: (value: unknown) => unknown[] = getCellValueAsArray;
  public readonly getCellValueAsString: (value: unknown) => string = getCellValueAsString;
  public readonly getCellValueAsStringOrDash: (value: unknown) => string = getCellValueAsStringOrDash;
  public readonly getTooltipValue: (tooltip: string | string[] | undefined) => string = getTooltipValue;
  public readonly getIconNameValue: (icons: string | string[] | undefined) => string = getIconNameValue;
  public readonly getIconNameByIndexValue: (icons: string | string[] | undefined, index: number) => string =
    getIconNameByIndexValue;
  public readonly cellValueIncludes: (cellValue: unknown, selected: unknown) => boolean = cellValueIncludes;
  public readonly getCellValueLength: (value: unknown) => number = getCellValueLength;

  public onCellChange(
    event: unknown,
    data: unknown,
    column: string,
    rowData: TableRow,
    options?: Record<string, unknown> | null,
    action?: string,
  ): void {
    this.cellChange.emit({ event, data, column, row: rowData, options, action });
  }

  public getCopyValue(): string {
    return getCellValueAsString(this.cell?.href ?? this.cell?.rawValue ?? this.cell?.value);
  }
}
